var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.deviceTypology == 'Blast Chiller')?_c('span',[_c('abatedor')],1):(_vm.checkIfNotBlastChiller)?_c('span',[_c('generic-device')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }